const destinations = new Set(["/", "/checkout", "/details", "/profile", "/history", "/delivery-options", "/invoice-options", "/policies", "/carrito"]);
export const safeReturnTarget = (value, fallback = "/") => destinations.has(value) || /^\/order-tracking\/[a-zA-Z0-9-]+$/.test(value || "") ? value : fallback;
export const loginDestination = (search, component = "") => {
  const target = new URLSearchParams(search).get("returnTo");
  return target !== null ? safeReturnTarget(target) : safeReturnTarget(`/${component}`);
};
export const checkoutLogin = "/login?returnTo=%2Fcheckout&back=%2F";
